//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const rating = ref(4.5)

    return {
      rating,
    }
  },
}
